import React from "react";
import Headers from "../Header/Header";
import "./abiutus.css";
import img1 from "../../assets/Rectangle 384.png";
import img2 from "../../assets/Rectangle 385.png";
const AboutUs = () => {
  return (
    <div className="abutus-box">
      <Headers />
      <div className="abutus-box-content">
        <div className="row d-flex flex-column-reverse flex-md-row  aboutus-sec1">
          <div className="col-md-6 text-sec-1">
            <h3>درباره ما</h3>
            <p>
              در راستای کمک به همشهریان عزیز برای دسترسی راحت و مطمئن به
              کارشناسان خبره و مورد تایید در حوزه تعیین قیت ملک در شان مردم عزیز
              شهر نجف آباد، سایت و اپلیکیشن آنلاین بومی "کجا نجف آباد" با تیمی
              مجرب و حرفه ای تاسیس و راه اندازی شده است.سایت و اپلیکیشن "کجا نجف
              آباد" یک پلتفرم نوبت دهی برای کارشناسان حوزه ملک در سطح شهرمان
              می‌باشد.{" "}
            </p>
          </div>
          <div className="col-md-6 p-0">
            <img alt="img1" src={img1} />
          </div>
        </div>
        <div className="row d-flex flex-column-reverse flex-md-row aboutus-sec2">
          <div className="col-md-6 p-0">
            <img alt="img1" src={img2} />
          </div>
          <div className="col-md-6 text-sec-2">
            <p>
              تنها با یک کلیک می‌توانید کارشناس مورد نظرتان را از بین بهترین
              کارشناسان مورد تایید در شهر انتخاب کنید. نوع و تعداد کارشناس‌ها در
              مناطق مختلف همراه با پشتیبانی سریع، "کجا نجف آباد" را به قطب
              نوبت‌دهی شهر مبدل خواهد کرد. همچنین این بستر تبدیل به یک مرجع
              مطمئن برای صحت‌سنجی اطلاعات کارشناسی هنگام معاملات ملکی خواهد شد و
              سدی مطمئن در برابر کلاه‌برداری‌های ممکن می‌باشد. امید است با حمایت
              شما مردم عزیز گامی بزرگ در راستای اقتصاد و اشتغالزایی جوانان
              شهرمان برداریم.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
